angular
    .module('multicrm')
    .factory('stateHandler', function ($rootScope, $state, Auth, Principal, ENV, VERSION, $transitions, $injector, PublicSettingsService) {
        return {
            initialize: initialize,
            returnTo: returnTo
        };

        function initialize() {
            $transitions.onBefore({}, function (transition) {
                if (transition.from() !== transition.to()) {
                    $rootScope.globalStateIsLoading = true;

                    const $uibModalStack = $injector.get('$uibModalStack');
                    $uibModalStack.dismissAll('state-change');
                }

                // let options = transition.options();
                // if(!options.reload){
                // }

                // if(transition.from().name !== ''){
                //     let queryParams = transition.params();
                //     console.log(transition.from().name, queryParams);
                // }


                var params = transition.to().data
                if (params && params.authorities && params.authorities.length > 0) {
                    if (Principal.isIdentityResolved()) {
                        return afterIdentityResolved()
                    } else {
                        return Auth.authorize().then(afterIdentityResolved)
                    }
                }

                function afterIdentityResolved() {
                    var hasRequiredAuthority = Principal.hasAnyAuthority(params.authorities);
                    if (hasRequiredAuthority === false) {
                        if (Principal.isAuthenticated()) {
                            return transition.router.stateService.target('access-denied', undefined);
                        } else {
                            return transition.router.stateService.target('login', undefined, {location: false});
                        }
                    }
                    return checkFeatureToggle()
                }

                return checkFeatureToggle()

                function checkFeatureToggle() {
                    if (!params || !params.featureToggle) {
                        return
                    }

                    return PublicSettingsService.get().then(settings => {
                        const features = settings.features || {}
                        if (features[params.featureToggle] !== true) {
                            return transition.router.stateService.target('access-denied', undefined)
                        }
                    })
                }
            });

            $transitions.onSuccess({}, function (transition) {
                var titleKey = 'global.title';
                var params = transition.to().data;
                if (params && params.pageTitle) {
                    titleKey = params.pageTitle;
                    // translationHandler.updateTitle(titleKey);
                }

                if (transition.from() !== transition.to()) {
                    $rootScope.globalStateIsLoading = false;
                }
                // let queryParams = transition.params()
                // $window.sessionStorage.setItem(transition.to().name, JSON.stringify(queryParams));
            });

            $transitions.onError({}, function (transition) {
                if (transition.from() !== transition.to()) {
                    $rootScope.globalStateIsLoading = false;
                }
            });

            $rootScope.ENV = ENV;
            $rootScope.VERSION = VERSION;
        }

        function returnTo($transition$) {
            if ($transition$.redirectedFrom() != null) {
                // The user was redirected to the login state (e.g., via the requiresAuth hook when trying to activate contacts)
                // Return to the original attempted target state (e.g., contacts)
                return $transition$.redirectedFrom().targetState();
            }
            var $state = $transition$.router.stateService;

            // The user was not redirected to the login state; they directly activated the login state somehow.
            // Return them to the state they came from.
            if ($transition$.from().name !== '') {
                return $state.target($transition$.from(), $transition$.params("from"));
            }

            // If the fromState's name is empty, then this was the initial transition. Just return them to the home state
            return $state.target('home');
        }
    });
